// extracted by mini-css-extract-plugin
module.exports = {"root":"Tombstone-root-493327877672bb36df471c470554f499","fullWidth":"Tombstone-fullWidth-1414f3bb0bf88a33347eef47c4a128a1"};